import { render, staticRenderFns } from "./SameLocationSuppliersListSection.vue?vue&type=template&id=4be16f65&"
import script from "./SameLocationSuppliersListSection.vue?vue&type=script&lang=js&"
export * from "./SameLocationSuppliersListSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports